// Presentational sub-components extracted from DesignUploadCard.js
// (structural refactor, July 2026 — no behavior change). These are pure:
// they receive data + callbacks as props and hold no state of their own.
import React from 'react';
import { Database, Loader2 } from 'lucide-react';

export function DataFormatBox({ design, onTrySample, loadingSample }) {
  return (
    <div className="rounded-lg p-4" style={{ background: 'var(--page-bg)', border: '1px solid var(--border-color)' }}>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-body mb-1" style={{ fontSize: 12, fontWeight: 600, color: 'var(--green-900)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Required Data Format
          </p>
          <code className="font-mono" style={{ fontSize: 13, color: 'var(--text-dark)', background: 'white', padding: '3px 8px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border-color)' }}>
            {design.format}
          </code>
        </div>
        {!design.noUpload && (
          <button
            onClick={onTrySample}
            disabled={loadingSample}
            className="flex items-center gap-1.5 font-body btn-press shrink-0 disabled:opacity-50 transition-colors"
            style={{
              fontSize: 12, fontWeight: 600, borderRadius: 'var(--radius-md)',
              padding: '6px 14px', border: '1.5px solid var(--green-700)',
              color: 'var(--green-700)', background: 'white',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--green-50)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'white'; }}
            data-testid={`sample-data-${design.key}`}
          >
            {loadingSample ? <Loader2 size={12} className="animate-spin" /> : <Database size={12} />}
            Try Sample Data
          </button>
        )}
      </div>
      {(design.key === 'diallel' || design.key === 'lxt') && (
        <p className="font-body mt-1" style={{ fontSize: 11, color: 'var(--text-light)' }}>Trait column auto-detected (Yield, PlantHeight, etc.)</p>
      )}
    </div>
  );
}

export function ValidationMessages({ errors = [], warnings = [] }) {
  return (
    <>
      {errors.length > 0 && (
        <div className="rounded-lg p-3 fade-in" style={{ border: '1px solid #FEB2B2', background: '#FFF5F5' }} data-testid="validation-errors">
          {errors.map((err, i) => (
            <p key={i} className="font-body flex items-start gap-2" style={{ fontSize: 13, color: '#C53030' }}>
              <span style={{ color: '#E53E3E', fontWeight: 700 }}>!</span> {err}
            </p>
          ))}
        </div>
      )}
      {warnings.length > 0 && (
        <div className="rounded-lg p-3 fade-in" style={{ border: '1px solid #FEFCBF', background: '#FFFFF0' }} data-testid="validation-warnings">
          {warnings.map((w, i) => (
            <p key={i} className="font-body flex items-start gap-2" style={{ fontSize: 13, color: '#975A16' }}>
              <span style={{ fontWeight: 700 }}>!</span> {w}
            </p>
          ))}
        </div>
      )}
    </>
  );
}

export function DuplicateBanner({ duplicateInfo, designLabel, onViewPrevious, onForceRerun }) {
  if (!duplicateInfo || (duplicateInfo.duplicates || []).length === 0) return null;
  return (
    <div
      className="mb-3 rounded-lg border-2 p-4"
      style={{ background: '#FFFBEB', borderColor: '#F59E0B' }}
      data-testid="duplicate-upload-banner"
    >
      <div className="flex items-start gap-3">
        <div className="text-2xl leading-none" aria-hidden="true">⚠️</div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm" style={{ color: '#92400E' }}>
            You've uploaded this file before
          </div>
          <div className="text-xs mt-1" style={{ color: '#92400E' }}>
            The {designLabel} module has {duplicateInfo.duplicates.length} matching analysis from the past 24h:
          </div>
          <ul className="text-xs mt-2 space-y-1" style={{ color: '#92400E' }}>
            {duplicateInfo.duplicates.slice(0, 3).map((d) => (
              <li key={d.id} className="font-mono">
                · {d.filename} — {new Date(d.created_at).toLocaleString()}
              </li>
            ))}
          </ul>
          <div className="flex gap-2 mt-3 flex-wrap">
            <button
              onClick={onViewPrevious}
              className="px-3 py-1.5 text-xs font-semibold rounded-md text-white"
              style={{ background: '#2D6A4F' }}
              data-testid="view-previous-result-button"
            >
              View Previous Result
            </button>
            <button
              onClick={onForceRerun}
              className="px-3 py-1.5 text-xs font-semibold rounded-md border-2"
              style={{ borderColor: '#F59E0B', color: '#92400E', background: 'white' }}
              data-testid="force-rerun-button"
            >
              Force Re-Run
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
